/** Shared react-hook-form rules for contact and newsletter forms. */

/** WCAG 1.3.5 autocomplete tokens keyed by react-hook-form field name. */
export const FIELD_AUTOCOMPLETE = {
  email: 'email',
  nameFirst: 'given-name',
  nameLast: 'family-name',
  phoneNumber: 'tel',
  zip: 'postal-code',
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const ZIP_PATTERN = /^\d{5}$/;
const PHONE_PATTERN = /^[+]?[\d\s().-]+$/;

export const EMAIL_FIELD_HINT = 'For example, name@example.com';
export const ZIP_FIELD_HINT = '5-digit ZIP code';
export const PHONE_FIELD_HINT = 'For example, (213) 555-1234';

export function isValidOptionalPhone(value) {
  const phone = String(value ?? '').trim();
  if (!phone) return true;
  if (!PHONE_PATTERN.test(phone)) return false;
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 11) return false;
  if (digits.length === 11 && digits[0] !== '1') return false;
  return true;
}

export const EMAIL_REGISTER_OPTIONS = {
  required: 'Email is required',
  pattern: {
    value: EMAIL_PATTERN,
    message: 'Enter a valid email address',
  },
};

export const ZIP_REGISTER_OPTIONS = {
  required: 'Zip code is required',
  validate: value => {
    const zip = String(value ?? '').trim();
    if (!ZIP_PATTERN.test(zip)) {
      return 'Enter a valid 5-digit zip code';
    }
    return true;
  },
};

export const PHONE_REGISTER_OPTIONS = {
  validate: value =>
    isValidOptionalPhone(value) ? true : 'Enter a valid phone number',
};
